var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Ima = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (!this.flags.isJoined) return 0
    if (!this.isDAI) {
      return this.getDuration() - this.player.getRemainingTime()
    }
    return this.playhead || 0
  },

  /** Override to return video duration */
  getDuration: function () {
    if (!this.isDAI) {
      if (this.player.getCurrentAd && this.player.getCurrentAd()) {
        this.lastDuration = this.player.getCurrentAd().getDuration()
        return this.lastDuration
      }
    } else {
      return this.duration
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getVastMediaWidth().toString() + 'x' +
        this.player.getCurrentAd().getVastMediaHeight().toString()
    } else {
      if (this.width && this.height)
        return this.width + 'x' + this.height
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getTitle()
    } else {
      return this.title
    }
    return null
  },

  /** Override to return title2 */
  getTitle2: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getAdvertiserName()
    } else {
      return this.advertiser
    }
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (!this.isDAI) {
      return this.player.getCurrentAd().getMediaUrl()
    }
    return null
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return google.ima.VERSION
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'IMA'
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    if (this.plugin.getAdapter() && !this.plugin.getAdapter().flags.isJoined) {
      return 'pre'
    }
    if (this.isDAI && this.plugin.getAdapter() && this.plugin.getAdapter().getIsLive()) return 'mid'
    return this.adPosition || 'mid'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // References
    this.references = []
    if (google.ima.AdEvent) {
      var event = google.ima.AdEvent.Type
      // Console all events if logLevel=DEBUG
      youbora.Util.logAllEvents(this.player.addEventListener, [null, event.LOADED, event.CONTENT_PAUSE_REQUESTED])

      this.references[event.CONTENT_PAUSE_REQUESTED] = this.playListener.bind(this)
      this.references[event.LOADED] = this.playListener.bind(this)
      this.references[event.PAUSED] = this.pauseListener.bind(this)
      this.references[event.STARTED] = this.playingListener.bind(this)
      this.references[event.RESUMED] = this.playingListener.bind(this)
      this.references[google.ima.AdErrorEvent.Type.AD_ERROR] = this.errorListener.bind(this)
      this.references[event.COMPLETE] = this.endedListener.bind(this)
      this.references[event.CONTENT_RESUME_REQUESTED] = this.endedListener.bind(this)
      this.references[event.SKIPPED] = this.skippedListener.bind(this)
      this.references[event.CLICK] = this.clickListener.bind(this)
      this.references[event.ALL_ADS_COMPLETED] = this.endedViewListener.bind(this)
      this.references[event.LOG] = this.logListener.bind(this)
    }
    // DAI
    if (google.ima.dai) {
      var eventDAI = google.ima.dai.api.StreamEvent.Type
      this.references[eventDAI.ERROR] = this.errorDAIListener.bind(this)
      this.references[eventDAI.AD_BREAK_STARTED] = this.startDAIListener.bind(this)
      this.references[eventDAI.AD_BREAK_ENDED] = this.stopDAIListener.bind(this)
      this.references[eventDAI.AD_PROGRESS] = this.progressDAIListener.bind(this)
      this.references[eventDAI.CLICK] = this.clickDAIListener.bind(this)
      // this.references[eventDAI.COMPLETE] = this.stopDAIListener.bind(this)
      this.references[eventDAI.STARTED] = this.joinDAIListener.bind(this)
    }
    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** DAI **/
  errorDAIListener: function (e) {
    this.fireError()
    this.fireStop()
  },
  startDAIListener: function (e) {
    this.isDAI = true
    this.playhead = 0
    this.adPosition = this.getAdPosition()
    this.duration = null
    this.plugin.fireInit() // if preroll
    this.fireStart()
  },
  progressDAIListener: function (e) {
    this.playhead = e.getStreamData()['adProgressData']['currentTime']
  },
  clickDAIListener: function (e) {
    this.fireClick()
  },
  stopDAIListener: function (e) {
    this.fireStop({ adPlayhead: this.duration })
    if (this.plugin.getAdapter()) this.plugin.getAdapter().fireResume()
  },
  joinDAIListener: function (e) {
    var adData = e.getAd()
    this.duration = adData.getDuration()
    this.title = adData.getTitle()
    this.width = adData.getVastMediaWidth()
    this.height = adData.getVastMediaHeight()
    this.advertiser = adData.getAdvertiserName()
    if (this.plugin.getAdapter()) this.plugin.getAdapter().firePause()
    this.fireJoin()
  },

  logListener: function (e) {
    if (e.getAdData() && e.getAdData()['adError']) {
      var error = e.getAdData()['adError']
      this.fireError(error.getErrorCode(), error.getMessage())
    }
  },

  /** Listener for 'play' and 'content_pause_requested' events. */
  playListener: function (e) {
    this.isDAI = false
    this.adPosition = this.getAdPosition()
    this.plugin.fireInit() // if preroll
    this.fireStart({ adPlayhead: "0" })
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' and 'resume' events. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin({ adPlayhead: "0" })
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
    this.fireStop()
  },

  /** Listener for 'ended' and 'content_resume_requested' events. */
  endedListener: function (e) {
    this.fireStop({ adPlayhead: this.lastDuration })
  },

  /** Listener for 'skipped' event. */
  skippedListener: function (e) {
    this.fireStop({ skipped: true, adPlayhead: this.getPlayhead() })
  },

  /** Listener for 'click' event. */
  clickListener: function (e) {
    var url = this.player.getCurrentAd().g.clickThroughUrl
    var now = new Date().getTime()
    if (this.lastUrl === url && now < ((this.lastTime || 0) + 2000)) {
      return
    }
    this.lastUrl = url
    this.lastTime = now
    this.fireClick({ 'url': url })
  },

  /** Listener for 'allAdsCompleted' event. */
  endedViewListener: function (e) {
    if (this.getPosition() === 'post') {
      this.plugin.fireStop({ end: true })
    }
    this.plugin.options['ad.afterStop'] = 0
  },

  getAdPosition: function () {
    if (!this.isDAI) {
      switch (this.player.getCurrentAd().getAdPodInfo().getTimeOffset()) {
        case 0:
          return 'pre'
        case -1:
          return 'post'
      }
      return 'mid'
    } else {
      if (this.plugin.getAdapter()) {
        if (!this.plugin.getAdapter().flags.isJoined || this.plugin.getAdapter().getPlayhead() < 1) {
          return 'pre'
        }
        return 'mid'
      }
    }
  }
})

module.exports = youbora.adapters.Ima
